import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/PurchaseReturnReport';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const PurchaseReturnReport = ({ t }) => (
  <Container>
    <Row>
      <HorizontalForm />
    </Row>

   
  </Container>
);

PurchaseReturnReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(PurchaseReturnReport);
